/**
 * Copyright 2024-2026 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export enum SegmentOperandValueEnum {
  LOWER_VALUE = 1,
  STARTING_ENDING_STAR_VALUE = 2,
  STARTING_STAR_VALUE = 3,
  ENDING_STAR_VALUE = 4,
  REGEX_VALUE = 5,
  EQUAL_VALUE = 6,
  GREATER_THAN_VALUE = 7,
  GREATER_THAN_EQUAL_TO_VALUE = 8,
  LESS_THAN_VALUE = 9,
  LESS_THAN_EQUAL_TO_VALUE = 10,
}
